module.exports = __webpack_public_path__ + "img/banner-12.c4ea0738.jpg";